import React from 'react'
import {graphql} from 'gatsby'
import Container from '../components/container'
import GraphQLErrorList from '../components/graphql-error-list'
import FontSingle from '../components/font-single'
import SEO from '../components/seo'
import Layout from '../containers/layout'
import {
  toPlainText,
  mapEdgesToNodes,
  filterOutDocsWithoutSlugs,
  filterOutCatsWithoutParents
} from '../lib/helpers'

export const query = graphql`
  query FontTemplateQuery($id: String!) {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      instagramLink
      facebookLink
      footer
      description
      twitter
      title
      email
      linkedInLink
      author
      keywords
      ccLink
      ccImage {
        ...SanityImage
        alt
      }
      image {
        ...SanityImage
        alt
      }
    }
    cats: allSanityCategory(sort: {fields: [title], order: ASC}, filter: {title: {ne: null}, }) {
      edges {
        node {
          title
          slug {
            current
          }
          parents {
            id
          }
        }
      }
    }
    font: sanityFont(id: {eq: $id}) {
      id
      images {
        desktopImage {
          ...SanityImage
          alt
          caption
        }
        mobileImage {
          ...SanityImage
          alt
          caption
        }
      }
      title
      family
      tester
      slug {
        current
      }
      _rawDescription(resolveReferences: {maxDepth: 5})
    }
  }
`

const FontTemplate = props => {
  const {data, errors} = props

  const site = (data || {}).site

  const catNodes = (data || {}).cats
    ? mapEdgesToNodes(data.cats)
      .filter(filterOutDocsWithoutSlugs)
      .filter(filterOutCatsWithoutParents)
    : []

  const font = data && data.font

  let fimage = '';

  if(font.images[0]) {
    fimage = font.images[0].desktopImage;
  }



  //console.log('font');
  //console.log(font);

  return (
    <Layout catNodes={catNodes} title={site.title} email={site.email} footer={site.footer} instagramLink={site.instagramLink} facebookLink={site.facebookLink} twitter={site.twitter} linkedInLink={site.linkedInLink} ccImage={site.ccImage} ccLink={site.ccLink} >
      {errors && <SEO title='GraphQL Error' />}
      {font && <SEO title={font.title || 'Untitled'} author={site.author} description={toPlainText(font._rawDescription)} image={fimage} />}

      {errors && (
        <Container>
          <GraphQLErrorList errors={errors} />
        </Container>
      )}

      {font && 
        <FontSingle {...font} />
      }
    </Layout>
  )
}

export default FontTemplate